import { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import TabConsultasPorTipo from '../components/TabConsultasPorTipo';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
        </div>
    );
}

export default function ReporteConsultasPorTipoPage() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                {/* Título principal */}
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
                        📑 Módulo de Consultas / Activaciones y Auditoria
                    </Typography>
                </Box>

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleTabChange}>
                        <Tab label="Consultas por Tipo" id="tab-0" aria-controls="tabpanel-0" />
                    </Tabs>
                </Box>

                {/* Tab Panels */}
                <TabPanel value={tabValue} index={0}>
                    <TabConsultasPorTipo />
                </TabPanel>
            </Box>
        </>
    );
}
